import React from 'react';
import { Paper, Box, Typography, CircularProgress, Alert } from '@mui/material';

const SectionCard = ({ title, controls, loading, error, isEmpty, emptyMessage = 'No data yet.', minHeight = 280, children }) => {
  return (
    <Paper sx={{ p: 3, height: '100%' }} variant="outlined">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="h6">{title}</Typography>
        {controls}
      </Box>
      <Box sx={{ minHeight }}>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: minHeight }}>
            <CircularProgress size={28} />
          </Box>
        ) : error ? (
          <Alert severity="error" variant="outlined">
            Couldn't load this section. {error}
          </Alert>
        ) : isEmpty ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: minHeight,
              color: 'text.secondary',
            }}
          >
            <Typography variant="body2">{emptyMessage}</Typography>
          </Box>
        ) : (
          children
        )}
      </Box>
    </Paper>
  );
};

export default SectionCard;
